/** Soft-interest option for Consular parent equity (not a fund vehicle). */
export const CONSULAR_EQUITY_SLUG = 'consular-capital';
export const CONSULAR_EQUITY_NAME =
  'Consular Capital Inc. (common stock · min $20,000)';

export function interestOptionLabel(slug: string, fallback?: string) {
  if (slug === CONSULAR_EQUITY_SLUG) return CONSULAR_EQUITY_NAME;
  return fallback || slug;
}
